import React from 'react'
import whyImg from "../../assets/images/home/whyImg.png";
import { Link } from 'react-router-dom';

export const WhySnapBid = () => {
  return (
    <div className='whyContainer'>
        <div className='container'>
            <div className='whySnapGrid'>
                <div className='whySnapLeft'>
                    <div className='whyTitle'>Why SnapBid</div>
                    <div className='whySubTitle'>Transparent. Flexible. Built for Real Buyers.</div>
                   <div className='whyList'>
                    <span>✅ No blind bidding means you always know what you're bidding for.</span>
                    <span>✅ Property visits are arranged before bidding so you can see it in person first.</span>
                    <span>✅ Only real and verified listings are shown with no fake posts or shady deals.</span>
                    <span>✅ Bidding happens only with like-minded buyers who have shown real interest.</span>
                    <span>✅ Login to track your interests and receive all related updates in one place.</span>
                   </div>
                   <div className='whyBtnContainer'>
                    <div className='btnWhyContact'><Link to="/contact"><button>Contact Us</button></Link></div>
                    <div className='btnWhyBrowse'><Link to="/properties"><button>Browse Properties</button></Link></div>
                   </div>

                </div>
                <div className='whySnapRight'>
                    <img src={whyImg}/>

                </div>

            </div>

        </div>
    </div>
  )
}
